<template>
  <transition name="moveR" v-if="num == 1">
    <div
      class="tab_container"
      :style="$route.path !== '/' ? 'background:rgba(255,64,64,1); ' : ''"
    >
      <div
        class="logo_icon"
        :style="$route.path !== '/' ? 'background-position: -289px -25px;' : ''"
        @click="changepage(nav[0])"
      ></div>
      <ul class="nav">
        <li
          v-for="(item, index) in nav"
          :key="index"
          @click="changepage(item)"
          :style="
            $route.path == item.path
              ? 'font-weight:500;  font-family: SourceHanSansCN-Medium;'
              : ''
          "
        >
          {{ item.name }}
          <p v-if="$route.path == item.path"></p>
        </li>
      </ul>
      <div class="login clearfix">
        <div class="loginOut" @click="loginOut">退出登录</div>
        <div class="headset" @click="addWx"></div>
        <div class="head_img">
          <img :src="userInfo.avatar" alt />
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
/* eslint-disable */
import { addmycustomer } from "../../api/index";
export default {
  props: {
    num: {
      type: Number
    }
  },
  data() {
    return {
      nav: [
        { name: "首页", path: "/" },
        { name: "上传作品", path: "/update" },
        { name: "作品库", path: "/product" }
      ],
      userInfo: {}
    };
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
    // console.log(this.userInfo);
  },
  methods: {
    async addWx() {
      let res = await addmycustomer();
      this.$emit("addWx", res.data.data.customQRCode);
    },
    loginOut() {
      window.localStorage.clear();
      this.$router.push({
        path: "/login"
      });
    },
    changepage(val) {
      if (val.path == this.$route.path) {
        return;
      }
      this.$router.push({ path: val.path });
    }
  }
};
</script>
<style lang="scss" scoped>
//,.moveR-leave-active

.moveR-enter-active {
  transition: all 0.3s linear;
  transform: translateY(0);
}
.moveR-enter,
.moveR-leave {
  transform: translateY(-100%);
}
.moveR-leave-to {
  transform: translateY(-100%);
}
.active {
  background: url("../../assets/jlt_pc.png") no-repeat;
  background-size: 535px 314px;
  background-position: -29px -25px;
  background-position: -289px -25px;
}
.tab_container {
  width: 100%;
  height: 80px;
  padding: 20px 131px 0;
  z-index: 999;
  position: absolute;
  min-width: 1366px;
  .logo_icon {
    cursor: pointer;
    width: 166px;
    height: 40px;
    background: url("../../assets/jlt_pc.png") no-repeat;
    background-size: 535px 314px;
    background-position: -29px -25px;
    float: left;
  }
  .nav {
    float: left;
    list-style: none;
    li {
      float: left;
      height: 40px;
      line-height: 40px;
      color: #fff;
      margin-right: 68px;
      cursor: pointer;
      font-size: 20px;
      font-family: SourceHanSansCN-Normal;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      p {
        width: 12px;
        height: 3px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        margin: 0 auto;
      }
    }
  }
  .login {
    float: right;
    height: 40px;
    line-height: 40px;
    text-align: right;
    cursor: pointer;
    .headset {
      width: 28px;
      height: 28px;
      background: url("../../assets/jlt_pc.png") no-repeat;
      background-size: 535px 314px;
      background-position: -228px -31px;
      float: left;
      margin-top: 6px;
      margin-right: 40px;
    }
    .head_img {
      width: 36px;
      height: 36px;
      overflow: hidden;
      border-radius: 50%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .loginOut {
      float: right;
      margin-left: 10px;
      font-size: 16px;
      font-family: SourceHanSansCN-Normal;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/tabBar.vue